import { Locale, type LocalizedString } from "../Locale.js";
import { NewsKind } from "../NewsKind.js";

export const newsKindNameMap: Record<NewsKind, LocalizedString> = {
	[NewsKind.Article]: {
		[Locale.cs]: "Článek",
	},
	[NewsKind.OneTimeArticle]: {
		[Locale.cs]: "Uzamčený článek",
	},
	[NewsKind.CaseStudy]: {
		[Locale.cs]: "Případová studie",
	},
	[NewsKind.Comparison]: {
		// TODO: think of a better name
		[Locale.cs]: "Srovnávač",
	},
};
